import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import LoginModuleTypes from '@/store/modules/login/interface';

const loginModule: Module<LoginModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {
        aesKey: '',
        userName: '',
        password: '',
        validationCode: '',
        isMustValid: false,
    },
    mutations: {
        aesKey(state, aesKey) {
            state.aesKey = aesKey;
        },
        isMustValid(state, isMustValid) {
            state.isMustValid = isMustValid;
        },
    },
    actions: {
        getAesKey(context) {
            tool.get("/login/getAesKey", {}).then(value => {
                context.commit('aesKey', value.result);
            });
        },
        saveLogin(context, params) {
            var password = tool.md5Encrypt(params.password);
            password = tool.aesEncrypt(context.state.aesKey.trim(), password);
            var paramMaps = {
                userName: params.userName,
                password: password,
                validationCode: params.validationCode,
            };
            return new Promise((resolve, reject) => {
                tool.post("/login/member_login", paramMaps).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        if(data.result!=null && data.result >=3){
                            //输错3次后，必须填写验证码
                            context.commit('isMustValid', true);
                        }
                        reject(data);
                    }
                });
            });
        },
        loginByToken(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/weixinWapApi/loginByToken", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        if(data.result!=null && data.result >=3){
                            //输错3次后，必须填写验证码
                            context.commit('isMustValid', true);
                        }
                        reject(data);
                    }
                });
            });
        },
        getErrorNumberByMemberCode(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/login/getErrorNumberByMemberCode", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        if(data.result!=null && data.result >=3){
                            //输错3次后，必须填写验证码
                            context.commit('isMustValid', true);
                        }
                        reject(data);
                    }
                });
            });
        },
    },
};

export default loginModule;